export default "__VITE_ASSET__CV2UeIm7__"